// extracted by mini-css-extract-plugin
module.exports = {"container":"_2ApKu","header":"UMpv1","link":"_1Pwup"};